import { render, staticRenderFns } from "./center1.vue?vue&type=template&id=2b83167a&scoped=true&"
import script from "./center1.vue?vue&type=script&lang=js&"
export * from "./center1.vue?vue&type=script&lang=js&"
import style0 from "./center1.vue?vue&type=style&index=0&id=2b83167a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83167a",
  null
  
)

export default component.exports